import { render, staticRenderFns } from "./CreateJudge.vue?vue&type=template&id=2f7b50e9&scoped=true"
import script from "./CreateJudge.vue?vue&type=script&lang=js"
export * from "./CreateJudge.vue?vue&type=script&lang=js"
import style0 from "./CreateJudge.vue?vue&type=style&index=0&id=2f7b50e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7b50e9",
  null
  
)

export default component.exports